import { Component, OnInit, inject } from '@angular/core';
import {MsAuthService} from '../../module/ms-auth';

@Component({
    selector: 'app-page-logout',
    templateUrl: './page-logout.component.html',
    styleUrls: ['./page-logout.component.scss'],
    standalone: false
})
export class PageLogoutComponent implements OnInit {
    private authService = inject(MsAuthService);


    ngOnInit(): void {
        this.authService.logout();
    }
}
